import { Utils } from './base/utils';
import { Navigation } from './navigation';
import { SliderBase } from './base/slider/SliderBase';

new Navigation();
new Utils();

const nodes: NodeListOf<HTMLElement> = document.querySelectorAll('.scroll-slider');
nodes.forEach((node: HTMLElement) => {
	new SliderBase({ target: node, itemsPerView: 1 });
});
